import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { useTimer } from '../../util/timer.js';
import { useEnterExitAnimation } from '../../util/useEnterExitAnimation.js';
import { Box } from '../Box/Box.js';
import { Notification } from './Notification.js';

var _excluded = ["actions", "onClose", "dismissible"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TOAST_NOTIFICATION_SHOW_TIME_MS = 5000;
var TOAST_NOTIFICATION_FADE_ANIMATION_TIME_S = '0.5s';
var ToastNotification = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var actions = _ref.actions,
    onClose = _ref.onClose,
    _ref$dismissible = _ref.dismissible,
    dismissible = _ref$dismissible === void 0 ? true : _ref$dismissible,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];
  var _useEnterExitAnimatio = useEnterExitAnimation({
      transition: "all ".concat(TOAST_NOTIFICATION_FADE_ANIMATION_TIME_S, " ease-in-out"),
      enterProps: {
        opacity: 1,
        transform: 'translate3d(0px, 0px, 0px)'
      },
      initialProps: {
        opacity: 0,
        transform: 'translate3d(0px, 42px, 0px)'
      },
      animationOn: show,
      animationFallBackTimeMs: 700
    }),
    transitionProps = _useEnterExitAnimatio.transitionProps,
    shouldRender = _useEnterExitAnimatio.shouldRender;
  var timerCallback = React.useCallback(function () {
    if (!actions) {
      setShow(false);
      onClose === null || onClose === void 0 || onClose('timer');
    }
  }, [actions, onClose]);
  var timer = useTimer({
    delay: TOAST_NOTIFICATION_SHOW_TIME_MS,
    callback: timerCallback
  });
  var handleOnClose = function handleOnClose() {
    setShow(false);
    onClose === null || onClose === void 0 || onClose('close');
    timer.destroy();
    return false;
  };
  var actionsWithClose = actions === null || actions === void 0 ? void 0 : actions.map(function (action) {
    return _objectSpread(_objectSpread({}, action), {}, {
      onClick: function onClick() {
        var _action$onClick;
        handleOnClose();
        (_action$onClick = action.onClick) === null || _action$onClick === void 0 || _action$onClick.call(action);
      }
    });
  });
  return shouldRender ? /*#__PURE__*/React.createElement(Box, _extends({
    "data-testid": "notification-toast",
    ref: ref,
    boxShadow: "bottom-m",
    borderRadius: "16"
  }, transitionProps), /*#__PURE__*/React.createElement(Notification, _extends({
    onClose: handleOnClose,
    actions: actionsWithClose
  }, dismissible && {
    closeButton: true
  }, rest))) : null;
});
ToastNotification.displayName = 'ToastNotification';

export { ToastNotification };
//# sourceMappingURL=ToastNotification.js.map
